


import { Component, Vue } from 'vue-property-decorator';

import GroupFilter from '@/shared/components/GroupFilter.component.vue';
import { CounterInterface } from '@/shared/components/counter/counter.interface.ts';
import { CounterColor } from '@/shared/components/counter/counter.enum.ts';

@Component({
    components: {
        GroupFilter,
    },
})

export default class PartialGroupFilter extends Vue {
  private counters: CounterInterface[] = [{
      value: 400,
      active: false,
      title: 'Convocados',
      color: CounterColor.Secondary,
      filter: undefined,
    }, {
      value: 0,
      active: false,
      title: 'Confirmados',
      color: CounterColor.Primary,
      filter: undefined,
    }, {
      value: 0,
      active: true,
      title: 'Posponen',
      color: CounterColor.Secondary,
      filter: undefined,
    }, {
      value: 400,
      active: false,
      title: 'No contestan',
      color: CounterColor.GreyDark,
      filter: undefined,
    }, {
      value: 2,
      active: false,
      title: 'Bajas',
      color: CounterColor.BlueDark,
      filter: undefined,
    }];

  private counterSelected: CounterInterface = this.counters[0];

  private counterClicked(counter: CounterInterface) {
    this.counterSelected = counter;
  }
}
